import { LoadingPage } from "@/component-nextv3/LoadingPage";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { AUTH_SETTING, REVALIDATE_SETTING } from "@/setting/setting";
import { IconButton, TextField } from "@mui/material";
import type { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { AiFillTool } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import { CardSlotProvider } from "../CasinoComponents/CardSlotProvider";
import { useProtectedAuthMeta } from "../context/useProtectedAuthMeta";
import { getCasinoProviders } from "../utils/getCasinoProviders";
import withHeader from "../utils/withHeader";
import styles from "./styles.module.scss";

export default function SlotsCasinoPage({ providers, deactivatedCasino }: any) {
	const { t } = useTranslation();
	const { isClient } = useResponsive();
	const [searchString, setSearchString] = useState<string>("");
	const [filteredProviders, setFilteredProviders] = useState<any>(providers);

	const loadProtectedAuth = useProtectedAuthMeta(AUTH_SETTING, "", "/");

	useEffect(() => {
		setFilteredProviders(providers);
	}, [providers]);

	useEffect(() => {
		const filteredProviders = providers.filter((item: any) =>
			item.name.toLowerCase().includes(searchString.toLowerCase()),
		);
		setFilteredProviders(filteredProviders);
	}, [searchString]);

	if (!loadProtectedAuth) {
		return <LoadingPage />;
	}

	if (!isClient) {
		return <></>;
	}

	const handleInputChange = (event: any) => {
		setSearchString(event.target.value);
	};

	const handleKeyDown = (event: any) => {
		if (event.key === "Enter") {
			setSearchString(event.target.value);
		}
	};

	const handleClearSearch = () => {
		setSearchString("");
		setFilteredProviders(providers);
	};

	return (
		<div className={styles.container}>
			<div className={styles.fieldsContainter}>
				<div className={styles.searchField}>
					<TextField
						style={{
							color: "white",
						}}
						placeholder={t("Pesquisa de nome de jogo")}
						value={searchString}
						onChange={handleInputChange}
						onKeyDown={handleKeyDown}
						InputProps={{
							endAdornment: searchString && (
								<IconButton onClick={handleClearSearch}>
									<MdClear />
								</IconButton>
							),
						}}
					/>
				</div>
				{/* <Select
                        className={styles.select}
                        value={selectedProvider}
                        onChange={handleFilter}
                    >
                        <MenuItem value={"default"}>{t("Todos os provedores")}</MenuItem>
                        {providers?.map(
                            (provider: any) =>
                                provider?.status && (
                                    <MenuItem key={provider.id} value={provider?.name}>
                                        {provider?.name.replaceAll("_", " ")}
                                    </MenuItem>
                                )
                        )}
                    </Select> */}
			</div>
			<div className={styles.casino}>
				<div className={styles.textContainer}>
					<img src="/assets/img/slot.png" alt="slot" />
					<div className={styles.headingContainer}>
						<div className={styles.heading}>{t("jogos de caça-níqueis")}</div>
						{/* <div className={styles.subHeading}>
                            {t(
                                "Mais de 1.000 slots principais com justiça garantida, classificados por popularidade"
                            )}
                        </div> */}
					</div>
				</div>

				<div className={styles.items}>
					{filteredProviders?.map((provider: any) =>
						provider?.maintenance || deactivatedCasino ? (
							<div key={provider.id} className={styles.slotContainer}>
								<CardSlotProvider provider={provider} />
								<div className={styles.overlay}>
									<AiFillTool />
								</div>
							</div>
						) : (
							provider?.status && (
								<CardSlotProvider provider={provider} key={provider.id} />
							)
						),
					)}
				</div>
			</div>
		</div>
	);
}

export const getStaticProps: GetStaticProps = ({ locale }) =>
	withHeader(async (props: any) => {
		return {
			props: {
				locale: locale,
				providers: (await getCasinoProviders()) || null,
				deactivatedCasino: props?.account?.deactivatedCasino || null,
			},
			revalidate: REVALIDATE_SETTING,
		};
	});

export { getStaticProps as GetStaticProps, SlotsCasinoPage };
